<div style="width: 100%; display: flex; justify-content: center">
  @if (processing) {
    <div>{{ processingState }}</div>
  }
</div>
